import { render } from "./StartingPoint.vue?vue&type=template&id=4fd82164&scoped=true"
import script from "./StartingPoint.vue?vue&type=script&lang=js"
export * from "./StartingPoint.vue?vue&type=script&lang=js"

import "./StartingPoint.vue?vue&type=style&index=0&id=4fd82164&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd82164"]])

export default __exports__